export enum FilterControlPanels {
  SEARCH,
  FILTER,
  LEGEND,
}
